import Case from '../routes/case'

export default Case
